
import React from "react";
import { TableCell } from "@material-ui/core";

export const Cell = ({
  selectableRef,
  isSelected,
  hour,
  weekDay,
}) =>
  isSelected ? (
    <TableCell
      className="cube selected"
      hour={hour}
      ref={selectableRef}
      id={weekDay}
    />
  ) : (
    <TableCell className="cube" hour={hour} ref={selectableRef} id={weekDay} />
  );

